"use client";
import { IAddressItem, ICheckoutStep } from "@/types/checkout";
import { create } from "zustand";

type TABS = "login" | "register";
interface CheckoutStore {
  activeStep: number | null;
  setActiveStep: (step: number | null) => void;
  steps: ICheckoutStep[];
  setSteps: (steps: ICheckoutStep[] | ((prevSteps: ICheckoutStep[]) => ICheckoutStep[])) => void;
  newAddressOpen: boolean;
  setNewAddressOpen: (open: boolean) => void;
  guestLoginLoading: boolean;
  setGuestLoginLoading: (open: boolean) => void;
  editingAddress: IAddressItem | null;
  setEditingAddress: (address: IAddressItem | null) => void;
  selectedAddressId: string;
  setSelectedAddressId: (id: string) => void;
  checkoutOtp: boolean;
  setCheckoutOtp: (otp: boolean) => void;
  checkoutActiveTab: TABS;
  setCheckoutActiveTab: (tab: TABS) => void;
  total: number;
  currency: string;
  setTotal: (total: number) => void;
  setCurrency: (currency: string) => void;
  amlChecked: boolean;
  setAmlChecked: (checked: boolean) => void;
}

// Create the Zustand store
export const useCheckoutStore = create<CheckoutStore>((set) => ({
  activeStep: null,
  total: 0,
  guestLoginLoading: false,
  setGuestLoginLoading: (loading: boolean) => set({ guestLoginLoading: loading }),
  currency: "CHF",
  setTotal: (total: number) => set({ total }),
  setCurrency: (currency: string) => set({ currency }),
  setActiveStep: (step) => {
    set({ activeStep: step });
    // Scroll to top when step changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  steps: [
    { title: "Account", step: 1, checked: false },
    { title: "Address", step: 2, checked: false },
    { title: "Payment", step: 3, checked: false },
  ],
  setSteps: (stepsOrUpdater) =>
    set((state) => ({
      steps: typeof stepsOrUpdater === "function" ? stepsOrUpdater(state.steps) : stepsOrUpdater,
    })),
  newAddressOpen: false,
  setNewAddressOpen: (open) => set({ newAddressOpen: open }),
  editingAddress: null,
  setEditingAddress: (address) => set({ editingAddress: address }),
  selectedAddressId: "0",
  setSelectedAddressId: (id) => set({ selectedAddressId: id }),
  checkoutOtp: false,
  setCheckoutOtp: (otp) => set({ checkoutOtp: otp }),
  checkoutActiveTab: "login",
  setCheckoutActiveTab: (tab) => set({ checkoutActiveTab: tab }),
  amlChecked: false,
  setAmlChecked: (checked) => set({ amlChecked: checked }),
}));
